module.exports = __webpack_public_path__ + "img/fondo.50866374.svg";